module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "item-value": "value",
      "label": "Broadcast Quarter"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d24114d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/BroadcastQuarterSelect.vue
// module id = 1993
// module chunks = 0